<template>
  <Modal :id="'cmp-artists-artist-add-filed'" @cancelled="onCancel">
    <template slot="header">{{$t('add')}} {{$t('custom_field')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          :id="'fieldLabel'"
          class="m1"
          required
          v-bind="textFieldConfig"
          v-model="fieldLabel"
          isModel
          :placeholder="$t('field_label')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button
        class="dt-button v1 s6"
        @click.stop="onField"
      >{{$t('add')}} {{$t('custom_field')}}</button>
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';

export default {
  components: {
    Modal,
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      fieldLabel: ""
      // Mark: Data
    };
  },
  mounted: function() {},
  watch: {},
  computed: {
    artistId: function() {
      return this.$route.query.artist_id;
    }
  },
  methods: {
    onTextFieldValueChange: function(name, value) {
      this.selectedCountry = value;
    },
    onCancel: function(event) {
      this.$emit("cancelled", true);
    },
    onField: function() {
      this.$emit("added", {
        fieldLabel: this.fieldLabel,
        artistId: this.artistId
      });
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss" scoped>
// .ckeditor-container {
//   .ck-editor {
//     width: 100%;
//   }

// }
</style>
